import { API_ENDPOINTS, API_BASE_URL, api } from "../apis/constants";
import { cacheService } from "./cache.service";

export interface Promotion {
    id: string;
    name: string;
    code: string;
    description: string;
    value: number;
    constraints: {
        minimum_order_amount: number;
        maximum_discount_amount: number | null;
    };
    quantity: {
        total: number;
        used: number;
    };
    time_constraints: {
        start_date: string;
        end_date: string;
    };
    type?: string; // 'percentage' or 'fixed_amount'
}

class PromotionService {
    private CACHE_KEY = 'public_promotions';
    private CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

    async getPublicPromotions(): Promise<Promotion[]> {
        try {
            // Use cache service with fetch function
            return await cacheService.get<Promotion[]>(
                this.CACHE_KEY,
                async () => {
                    const response = await api.get(API_ENDPOINTS.PROMOTIONS.PUBLIC);
                    return response.data;
                },
                { ttl: this.CACHE_DURATION }
            );
        } catch (error) {
            console.error('Error fetching public promotions:', error);
            return [];
        }
    }

    async validatePromoCode(code: string, orderAmount: number): Promise<any> {
        try {
            const endpoint = `${API_BASE_URL}/promotions/validate/${code}`;
            const response = await api.get(endpoint, {
                params: { orderAmount }
            });
            return response.data;
        } catch (error) {
            console.error('Error validating promotion code:', error);
            throw error;
        }
    }
}

export const promotionService = new PromotionService(); 